var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "752pt",
    height: "752pt",
    viewBox: "0 0 752 752",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m562.59 509.55-162.44-297.41c-2.3672-4.2617-5.6836-8.0508-9.9453-10.418-4.2617-2.3672-8.9961-3.7891-13.734-3.7891-4.7344 0-9.4727 1.4219-13.734 3.7891-4.2617 2.3672-7.5781 6.1562-9.9453 10.418l-162.43 297.41c-4.7344 8.9961-4.7344 17.996 0.47266 26.52 2.3672 4.2617 5.6836 10.418 9.9453 12.785 4.2617 2.3672 8.5234 6.6289 13.262 6.6289h324.88c4.7344 0 9.4727-4.2617 13.262-6.6289 4.2617-2.3672 7.5781-7.1055 9.9453-11.367 5.207-8.5195 5.207-18.938 0.47266-27.938zm-215.01-177.12c0-14.68 11.367-26.52 26.047-26.52 14.68 0 26.047 11.84 26.047 26.52v79.562c0 14.68-11.367 26.52-26.047 26.52-14.68 0-26.047-11.84-26.047-26.523zm29.363 173.33c-14.68 0-26.52-11.84-26.52-26.52 0-14.68 11.84-26.52 26.52-26.52 14.68 0 26.52 11.84 26.52 26.52 0 14.68-11.84 26.52-26.52 26.52z",
    fill: "#ffff00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.64306d2dd034587941b163527054802a.svg";
export { ForwardRef as ReactComponent };